module.exports = __webpack_public_path__ + "img/warning_red.3516e6b0.svg";